// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';

export const StyledFooter = styled.footer`
  padding: 0.75rem 0;
  text-align: center;

  svg {
    vertical-align: bottom;
    width: 120px;
    height: 33px;
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    padding: 2rem 0 1.5rem;

    svg {
      width: 152px;
      height: 42px;
    }
  }
`;

export const StyledCopyright = styled.p`
  margin-top: 1rem;
  font-size: ${(props) => props.theme.fontSizes.small.fontSize};
  line-height: ${(props) => props.theme.fontSizes.small.lineHeight};
  text-align: left;
  display: flex;
  justify-content: center;

  ${({ theme }) => theme.mediaQueries.min.md} {
    margin-top: 2rem;
  }
`;
